//@ts-check
import { useContext, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { OrContext } from "../../components/or/OrContext";

export const useORRequests = () => {
    const orContext = useContext(OrContext);
    return orContext.orRequests;
}